import {EmbeddingType} from 'common/src/modules/ragSearch/ragSearch.enums';
import {ToolName} from '../copilot.enums';
import {generalKnowledgeToolSchema} from '../copilot.schemas';
import {ToolExecuteParams, ToolResult} from '../copilot.types';
import tool from '../utils/creators/tool';
import invokeRagArticleSearch from '../utils/invokeRagArticleSearch';

export function generalKnowledgeTool() {
  async function execute({
    input: {prompt},
    toolUtils,
    callChain,
  }: ToolExecuteParams<typeof generalKnowledgeToolSchema>): Promise<ToolResult> {
    const result = await invokeRagArticleSearch({
      prompt,
      embeddingTypes: [
        EmbeddingType.ProductDocumentation,
        EmbeddingType.Agency,
        EmbeddingType.PublicApi,
      ],
      toolUtils,
      callChain,
    });

    return result;
  }

  return tool({
    name: ToolName.GeneralKnowledge,
    displayName: 'Searching knowledge',
    description: `Search for answers in the product documentation. 
#### Strict rules for running the ${ToolName.GeneralKnowledge} tool:
- Don't use this tool if the user's question is related to a specific resource. Use the ${ToolName.ResourceKnowledge} tool instead.
- **Only use the provided answer from the search tool.**
- Do **not** add explanations, assumptions, examples, suggestions, or code - even the tool didn't fully answer the question.
- Do **not** give a placeholder answer such as "one moment while I check"
- If the user asks a question in a language other than English, translate the question to English before attempting to answer, and respond in the same language.`,
    execute,
    inputSchema: generalKnowledgeToolSchema,
    isReadonly: true,
  });
}
